import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  municipality: string;
  inProgress: boolean;
  children: React.ReactNode;
}

const ProportionalMapDetails = ({ municipality, inProgress, children }: Props) => {
  const { t } = useTranslation('wap');

  const title = inProgress ? t('map_in_progress', { municipality }) : municipality;
  return (
    <div className="proportionalmap__details">
      <h2 className="h3">{title}</h2>
      <div className="proportionalmap__partybars">{children}</div>
    </div>
  );
};

export default ProportionalMapDetails;
